var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',_vm._g({class:[
    _vm.$style['tab'],
    {
      [_vm.$style['active']]: _vm.active,
    }
  ]},_vm.$listeners),[_vm._t("default"),_vm._v(" "),(_vm.arrow)?_c('span',{class:_vm.$style['button__arrow']},[_c('ButtonArrow')],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }